// extracted by mini-css-extract-plugin
module.exports = {"confirm-parent-banner":"styles_confirm-parent-banner__2Q2VC","buttons":"styles_buttons__1hBBb"};